import ActionTypes from '../actions/types';

const initialState = {
  all: [],
};
// in this camera function, you can add actions that update state data.

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_CAM_LIST:
    case ActionTypes.SET_CAM_LIST:
      return {
        ...state,
        all: action.payload,
      };
    default:
      return state;
  }
}
